import { useChannelStoreHook } from "@/store/modules/channel";

const updateConfig = (key, value) => {
  const ArmsRum = window.RumSDK?.default;
  if (ArmsRum) {
    ArmsRum.setConfig(key, value);
  }
};

/**
 *
 * @param user
 */
export const updateArmsUser = user => {
  updateConfig("user", {
    name: user?.no ?? ""
  });
};

/**
 * Update the properties for logging
 */
export const updateArmsProperties = () => {
  updateConfig("properties", {
    channel: useChannelStoreHook().channel?.key || "",
    client: "y-platform",
    version: "",
    versionCode: ""
  });
};
